let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l08wq")).then(() => parcelRequire('9jve4'));